import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';

import * as S from './styles';
import Avatar from 'base/src/components/Avatar';
import { formatCPF } from 'base/src/utils/stringUtil';

interface UserProps {
  user: UsuarioResponse;
}

function HoverAvatar({ user }: UserProps) {
  return (
    <S.CardContainer>
      <S.UserInfo>
        <Avatar size='md' alt={user.NomeCompleto} fallBack='ss' borderColor='transparent' src={user.ImagemUrl} />
        <S.UserDetails>
          <S.Title>{user.NomeCompleto}</S.Title>
          <S.Subtitle>{user.UsuarioAcesso}</S.Subtitle>
        </S.UserDetails>
      </S.UserInfo>
      <S.InfoBlock>
        <S.InfoRow>
          <S.Title>CPF:</S.Title>
          <S.Subtitle>{formatCPF(user.CPF)}</S.Subtitle>
        </S.InfoRow>
        <S.InfoRow>
          <S.Title>E-mail:</S.Title>
          <S.Subtitle>{user.Email}</S.Subtitle>
        </S.InfoRow>
        <S.InfoRow>
          <S.Title>Chave Pix:</S.Title>
          <S.Subtitle>{user.ChavePix}</S.Subtitle>
        </S.InfoRow>
      </S.InfoBlock>
    </S.CardContainer>
  );
}

export default HoverAvatar;